<template>
  <div class="main">
    <MyHeader index="2"></MyHeader>
    <div class="titleIfo">
      <div class="container" v-if=" this.$i18n.locale == 'zh_CN'">
        <h2>合作伙伴</h2>
        <h3>Partners</h3>
      </div>
      <div class="container" v-if=" this.$i18n.locale == 'en_US'">
        <h2>Partners</h2>
        <h3>合作伙伴</h3>
      </div>
    </div>
    <div class="partnersUsInfo">
      <div class="container">
        <div class="content">
          <div class="leftMenu">
            <ul>
              <li>
                <router-link to="partner">
                  <i>{{$t('partner.tit')}}</i>
                  <b></b>
                </router-link>
              </li>
              <li class="on">
                <router-link to="partners">
                  <i>{{$t('partner.tit1')}}</i>
                  <b></b>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="rightContent">
            <h3>{{$t('join.qualifications')}}</h3>
            <p>{{$t('join.txt')}}</p>
            <p>{{$t('join.txt1')}}</p>
            <p>{{$t('join.txt2')}}</p>
            <h3>{{$t('or.qualifications')}}</h3>
            <p>{{$t('or.txt')}}</p>
            <p>{{$t('or.txt1')}}</p>
            <h3>{{$t('how.qualifications')}}</h3>

            <div class="table">
              <div class="double">
                <div class="item left" :class="flag1?'line':'text'">{{$t('how.one')}}</div>
                <div class="item right line">{{$t('how.two')}}</div>
              </div>
              <div class="item Single line">{{$t('how.three')}}</div>
              
              <div class="item Single line" v-if=" this.$i18n.locale == 'zh_CN'">{{$t('how.four')}}</div>
              <div class="item Single line" style="height:80px;" v-if=" this.$i18n.locale != 'zh_CN'">{{$t('how.four')}}</div>
              
              <div class="item Single line">{{$t('how.five')}}</div>
              <div class="item Single line">{{$t('how.six')}}</div>
              <div class="item Single line">{{$t('how.seven')}}</div>
              <div class="item Single line">{{$t('how.eight')}}</div>
            </div>
            <h3>{{$t('form.title')}}</h3>

            <div class="form">
              <form action="#" @submit.prevent="onSubmit">
                <ul>
                  <li>
                    <i class="must">{{$t('form.name')}}</i>
                    <input
                      type="text"
                      v-model="form.name"
                      :placeholder="$t('formPlaceholder.name')"
                    />
                  </li>
                  <h2 class="error" id="name">{{$t('formError.name')}}</h2>
                  <li>
                    <i class="must">{{$t('form.person')}}</i>
                    <input
                      type="text"
                      v-model="form.representative"
                      :placeholder="$t('formPlaceholder.person')"
                    />
                  </li>
                  <h2 class="error" id="representative">{{$t('formError.person')}}</h2>
                  <li>
                    <i>{{$t('form.Recommender')}}</i>
                    <input
                      type="text"
                      v-model="form.referee"
                      :placeholder="$t('formPlaceholder.Recommender')"
                    />
                  </li>

                  <li>
                    <i>{{$t('form.Contacts')}}</i>
                    <input
                      type="text"
                      v-model="form.linkman"
                      :placeholder="$t('formPlaceholder.Contacts')"
                    />
                  </li>

                  <li>
                    <i class="must">{{$t('form.tel')}}</i>
                    <input
                      type="text"
                      v-model="form.contact_info"
                      :placeholder="$t('formPlaceholder.tel')"
                    />
                  </li>
                  <h2 class="error" id="contact_info">{{$t('formError.tel')}}</h2>
                </ul>
                <input type="submit" :value="$t('label.submit')" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="popup" v-show="success" @click="popupClick">
      <div class="info sun-Middle">
        <img src="./image/Success.png" alt="Success" />
        <h3>{{$t('label.submittitle')}}</h3>
        <h4>{{$t('label.submitmsg')}}</h4>
      </div>
    </div>
    <MyFooter></MyFooter>
  </div>
</template>

<script>
import MyHeader from "./common/MyHeader";
import MyFooter from "./common/MyFooter";
import $ from "jquery";

export default {
  name: "PartnersPage",
  components: { MyHeader, MyFooter },
  data() {
    return {
      form: {
        name: "",
        representative: "",
        referee: "",
        linkman: "",
        contact_info: ""
      },
      success: false,
      flag: true,
      flag1:true
    };
  },
  mounted(){
      if (this.$i18n.locale == 'en_US') {
                    this.flag1 = false
                } else {
                    this.flag1 = true
                }
  },
  methods: {
    onSubmit() {
      var currtime = new Date().getTime();
      // console.log(localStorage.flag)
      if (!localStorage.flag) {
        localStorage.setItem(
          "flag",
          JSON.stringify({ data: true, time: currtime })
        );
        if (this.form.name === "") {
          $("#name").show();
          return;
        } else {
          $("#name").hide();
        }
        if (this.form.representative === "") {
          $("#representative").show();
          return;
        } else {
          $("#representative").hide();
        }
        if (this.form.contact_info === "") {
          $("#contact_info").show();
          return;
        } else {
          $("#contact_info").hide();
        }
        const form = this.form;
        this.axios
          .post("/application", form)
          .then(res => {
            this.success = true;
            // console.log(this.success)
          })
          .catch(err => {});
      } else if (
        localStorage.flag &&
        currtime - JSON.parse(localStorage.getItem("flag")).time < 1000 * 5) {
        //alert("不能重复提交");
      } else if (
        localStorage.flag &&
        currtime - JSON.parse(localStorage.getItem("flag")).time > 1000 * 5) {
        if (this.form.name === "") {
          $("#name").show();
          return;
        } else {
          $("#name").hide();
        }
        if (this.form.representative === "") {
          $("#representative").show();
          return;
        } else {
          $("#representative").hide();
        }
        if (this.form.contact_info === "") {
          $("#contact_info").show();
          return;
        } else {
          $("#contact_info").hide();
        }
        const form = this.form;
        this.axios
          .post("/application", form)
          .then(res => {
            this.success = true;
            // console.log(this.success)
          })
          .catch(err => {});
      }
    },
    popupClick() {
      this.success = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  .titleIfo {
    width: 100%;
    height: 380px;
    background: url("./image/partners.jpg") no-repeat center center;
    background-size: cover;

    .container {
      h2 {
        padding-top: 180px;
        text-align: center;
        color: #ffffff;
        height: 42px;
        font-size: 32px;
        font-weight: bold;
        line-height: 42px;
      }

      h3 {
        text-align: center;
        height: 29px;
        font-size: 22px;
        line-height: 29px;
        color: #ffffff;
      }
    }
  }

  .partnersUsInfo {
    .container {
      border-top: 1px solid #e6e6e6;

      .content {
        margin-top: 66px;
        overflow: hidden;
        margin-bottom: 48px;

        .leftMenu {
          width: 246px;
          float: left;

          ul {
            li {
              padding: 0 16px;
              border-radius: 18px;
              height: 36px;
              overflow: hidden;
              line-height: 36px;
              margin-bottom: 10px;

              .a {
                display: block;
              }

              &:last-child {
                margin-bottom: 0;
              }

              i {
                display: inline-block;
                float: left;
                color: #252525;
                font-size: 16px;
              }

              b {
                display: inline-block;
                float: right;
                width: 30px;
                height: 100%;
                background: url("./image/yy2.png") no-repeat center center;
                background-size: 100%;
                line-height: 36px;
              }
            }

            .on {
              background: #13ae67;

              i {
                color: #ffffff;
              }

              b {
                background: url("./image/yy.png") no-repeat center center;
                background-size: 86%;
              }
            }
          }
        }

        .rightContent {
          float: right;
          margin-left: 88px;
          width: 866px;

          h3 {
            font-size: 16px;
            font-weight: bold;
            border-left: 3px #44be86 solid;
            padding-left: 10px;
            color: #252525;
            height: 20px;
            line-height: 20px;
            margin-bottom: 20px;
          }

          p {
            font-size: 16px;
            color: #252525;
            margin-bottom: 40px;
          }

          .table {
            margin-bottom: 40px;
            border: 1px solid #e7e7e7;
            padding: 32px 0;
            position: relative;

            .item {
              border: 1px solid #08a2e8;
              height: 38px;
              
              text-align: center;
              color: #08a2e8;
              font-size: 14px;
              border-radius: 6px;

              &:after {
                margin-top: 8px;
                content: " ";
                display: block;
                width: 24px;
                height: 14px;
                background: url("./image/nabla.png") no-repeat center center;
                background-size: 100% 100%;
              }

              &:nth-of-type(7n) {
                &:after {
                  display: none;
                }
              }
            }

            .left {
              &:after {
                margin-left: 242px;
              }
            }

            .right {
              &:after {
                margin-left: 60px;
                line-height: 0;
              }
            }

            .Single {
              margin: 0 auto 26px;
            }

            .Single {
              &:after {
                margin: 8px auto 0;
              }
            }

            .double {
              width: 730px;
              margin: 0 auto 10px;
              height: 60px;
            }

            .line{
                width: 326px;
                line-height: 38px;
            }

            .text{
                width: 316px;
                text-align: left;
                padding-left: 10px;
            }
          }

          .form {
            border: 1px solid #f2f2f2;
            padding: 28px 0 40px;

            form {
              .error {
                margin-left: 245px;
                font-size: 12px;
                color: red;
                margin-bottom: 20px;
                display: none;
              }

              ul {
                li {
                  overflow: hidden;
                  margin-bottom: 20px;

                  &:last-child {
                    margin-bottom: 0;
                  }

                  i {
                    float: left;
                    display: block;
                    width: 182px;
                    color: #252525;
                    font-size: 12px;
                    height: 32px;
                    line-height: 32px;
                    margin-left: 48px;
                    text-align: right;
                  }

                  .must {
                    &:after {
                      content: "*";
                      display: inline;
                      color: #f15531;
                      font-size: 16px;
                    }
                  }

                  input {
                    font-size: 12px;
                    margin-left: 16px;
                    padding: 0 16px;
                    float: left;
                    display: block;
                    width: 440px;
                    height: 32px;
                    background: #ffffff;
                    border: 1px solid #e1e1e1;
                    border-radius: 3px;
                  }
                }
              }

              input[type="submit"] {
                display: block;
                margin: 42px auto 0;
                width: 96px;
                height: 30px;
                line-height: 30px;
                background: #44be86;
                border-radius: 3px;
                border: none;
                color: #ffffff;
              }
            }
          }
        }
      }
    }
  }

  .popup {
    position: fixed;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.36);

    .info {
      background: #ffffff;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      width: 300px;
      height: 172px;

      img {
        width: 46.5px;
        height: 46.5px;
        margin: 33px auto 0;
      }

      h3 {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.75);
        margin-top: 12px;
        line-height: 20px;
        text-align: center;
      }

      h4 {
        margin-top: 6px;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.65);
        line-height: 20px;
        text-align: center;
      }
    }
  }
}
</style>